import { render } from "./DocumentExecutionNotesForm.vue?vue&type=template&id=1b18d8ee&ts=true"
import script from "./DocumentExecutionNotesForm.vue?vue&type=script&lang=ts"
export * from "./DocumentExecutionNotesForm.vue?vue&type=script&lang=ts"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__